import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Links } from '../Models/links';
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { environment } from '../../environments/environment';
import { SpinnerService } from './spinner';


@Injectable()
export class Config {

  private urls: Links = null;
  private settings = new BehaviorSubject<Map<string, any>>(new Map<string, any>());
  public initialContentLang: string = null;
  public base = environment.engine_endpoint_url;
  public token_storage_key = 'feniks_token';
  public lang_storage_key = 'feniks_lang';
  public request_timeout: number = 10000;

  constructor(private http: HttpClient,
              private spinner: SpinnerService) { }

  public getURL(model): string {
    return this.urls && this.urls[model];
  }

  public getSettings(): Observable<Map<string, any>> {
    return this.settings.asObservable();
  }

  private _load_base_config() {
    return this.http
      .get<Links>(this.base, { observe: 'response' })  // get http headers as well
      .toPromise()
      .then((response: HttpResponse<Links>) => {
        // use the content language from the backend. it has aleady performed
        // the content negotiation so we know this is a supported language
        let contentLanguage = response.headers.get('Content-Language');
        if(contentLanguage) {
          contentLanguage = contentLanguage.substring(0, 2).toLowerCase();
          this.initialContentLang = contentLanguage;
        }

        this.urls = response.body;

        this.http.get<Map<string, any>>(this.getURL("settings")).subscribe(
          data => { this.settings.next(data); }
        );

        this.spinner.stop();
      });
  }

  private delay(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  private _recursive_load_base_config() {
    return this._load_base_config()
      .catch((err: any) => {

        // just keep on reloading every x seconds
        return this.delay(5000).then(() => {
          return this._recursive_load_base_config()
        });
      });
  }

  load(): Promise<any> {
    // we MUST load the base rest call successfully because it has the
    // configuration of all the links so this will keep on retrying
    // until we have success!
    this.spinner.start();
    return this._recursive_load_base_config();
  }

}



// WEBPACK FOOTER //
// ./src/app/Services/config.ts